import {
  DO_FETCH_REQUEST,
  DO_FETCH_SUCCESS,
  DO_FETCH_FAILURE,
  DO_CLEAR
} from './doActions'

const INITIAL_STATE = {
  itens: [],
  total: 0,
  filtros: {
    dataInicial: '',
    dataFinal: ''
  },
  loading: false,
  loaded: false,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DO_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case DO_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        itens: action.payload.itens,
        total: action.payload.total,
        filtros: action.payload.filtros
      }

    case DO_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case DO_CLEAR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}